import moment from 'moment';
import _ from 'lodash';

export default {
    filters: {
        L(value) {
            if (!value) return '';
            return moment(value).format('L');
        },

        LL(value) {
            if (!value) return '';
            return moment(value).format('LL');
        },

        LLL(value) {
            if (!value) return '';
            return moment(value).format('LLL');
        },

        LLLL(value) {
            if (!value) return '';
            return moment(value).format('LLLL');
        },

        LT(value) {
            if (!value) return '';
            return moment(value).format('LT');
        },

        LTS(value) {
            if (!value) return '';
            return moment(value).format('LTS');
        },

        fromNow(value) {
            if (!value) return '';
            return moment(value).fromNow();
        },

        dateLabel(value) {
            if (!value) return '';

            const input = moment(value);
            const now = moment();
            const diffHours = now.diff(input, 'hours');
            const today = now.clone().startOf('day');
            const yesterday = now.clone().subtract(1, 'day').startOf('day');

            if (diffHours <= 24) {
                return input.fromNow(); // e.g., "5 hours ago"
            } else if (input.isSame(today, 'day')) {
                return 'Today';
            } else if (input.isSame(yesterday, 'day')) {
                return 'Yesterday';
            } else {
                return input.format('LL'); // e.g., "July 15, 2025"
            }
        },

        capitalize(value) {
            if (!value) return '';
            return _.capitalize(value);
        },

        readableDate(date) {
            if (date) return moment(date).format('DD MMM, YYYY hh:mm:ss');
            return date;
        },

        dateOnly(date) {
            if (date) return moment(date).format('DD MMM, YYYY');
            return date;
        },
    },
};
